<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="680px"
      :persistent="false"
    >
      <v-form
        ref="form"
      >
        <v-card
          v-if="item"
          :color="getItemColor(item)"
          class="rounded"
          style="padding: 5px 7px 5px 7px;"
          tile
        >
          <v-card-title class="pt-3 pb-7">
            <v-row>
              <v-col>
                <v-row
                  align="center"
                >
                  <v-col class="pt-1 pb-1 pl-1">
                    <v-chip
                      small
                      color="#FFFFFF"
                      text-color="#01579B"
                    >
                      {{ getItemName(item) }}
                    </v-chip>
                  </v-col>
                  <v-spacer />
                  <v-col
                    class="pt-1 pb-1"
                    cols="auto"
                  >
                    <v-btn
                      v-if="!item.is_material_available && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor))"
                      class="elevation-0"
                      color="#FFFFFF"
                      small
                      @click="finishStage(item.id, materialAvailableId)"
                    >
                      <span style="color: #01579B;">FINISH MATERIAL</span>
                    </v-btn>
                    <v-btn
                      v-if=" (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                      class="elevation-0"
                      color="#FFFFFF"
                      small
                      @click="toggle(item.id, item.status_id)"
                    >
                      <span style="color: #01579B;">COMPLETE</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="auto"
                    class="pr-6 pl-0"
                  >
                    <v-menu offset-y>
                      <template #activator="{ on, attrs }">
                        <v-btn
                          elevation="0"
                          fab
                          color="#FFFFFF"
                          x-small
                          v-bind="attrs"
                          tile
                          style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                          v-on="on"
                        >
                          <v-icon style="color: #01579B;">
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list
                        class="pa-3"
                      >
                        <v-list-item
                          v-if="item.status_id === statusIdInProgress && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                          @click="openEdit(item)"
                        >
                          <v-list-item-title style="color: #1976d2; font-weight: 600;">
                            EDIT
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate)) && item.status_id == statusIdInProgress"
                          @click="softDelete(item.id)"
                        >
                          <v-list-item-title style="color: #ff5252; font-weight: 600;">
                            DELETE
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor)"
                          @click="openNotes(item.id)"
                        >
                          <v-list-item-title style="color: #ff9800; font-weight: 600;">
                            NOTES {{ item.notes ? `(${item.notes.length})` : '' }}
                          </v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="openHistory(item)">
                          <v-list-item-title style="color: #FDD835; font-weight: 600;">
                            HISTORY
                          </v-list-item-title>
                        </v-list-item> -->
                        <v-list-item
                          v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate)) && item.status_id == statusIdInProgress"
                          @click="toggle(item.id, item.status_id, true)"
                        >
                          <v-list-item-title style="color: purple; font-weight: 600;">
                            ARCHIVE
                          </v-list-item-title>
                        </v-list-item>
                        <!-- <v-divider />
                        <v-list-item
                          v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                          @click="openTruckForm(item)"
                        >
                          <v-list-item-title
                            style="color: gray; font-weight: 600;"
                          >
                            <v-icon
                              small
                              class="mr-1 mb-1"
                              color="gray"
                            >
                              fas fa-plus
                            </v-icon> ADD TRUCK
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="((roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))) && item.truck_schedule_total > 0"
                          @click="redirectTrucks(item.job_id)"
                        >
                          <v-list-item-title
                            style="color: gray; font-weight: 600;"
                          >
                            VIEW TRUCKS {{ `(${item.truck_schedule_total})` }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item
                          v-if="!item.is_splander_paint && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                          @click="finishStage(item.id, spandrelId)"
                        >
                          <v-list-item-title style="color: #F7014C; font-weight: bold;">
                            FINISH SPANDREL
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-else-if="item.is_splander_paint && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                          @click="cancelStage(item.id, spandrelId)"
                        >
                          <v-list-item-title style="color: #F7014C; font-weight: bold;">
                            CANCEL SPANDREL
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="!item.is_panels && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                          @click="finishStage(item.id, panelsId)"
                        >
                          <v-list-item-title style="color: #1874A7; font-weight: bold;">
                            FINISH PANELS
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-else-if="item.is_panels && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                          @click="cancelStage(item.id, panelsId)"
                        >
                          <v-list-item-title style="color: #1874A7; font-weight: bold;">
                            CANCEL PANELS
                          </v-list-item-title>
                        </v-list-item> -->
                        <v-list-item
                          v-else-if="item.is_material_available && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor))"
                          @click="cancelStage(item.id, materialAvailableId)"
                        >
                          <v-list-item-title style="color: #F9A825; font-weight: 600;">
                            CANCEL MATERIAL
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider
                v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'"
                vertical
                inset
                style="max-height: 30px; margin-top: 15px;"
              />
              <v-col
                cols="auto"
                class="text-end pr-0"
              >
                <v-btn
                  icon
                  @click="dialog = false"
                >
                  <v-icon
                    color="#FFFFFF"
                  >
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text
            style="background-color: #FFFFFF; border-radius: 5px;"
          >
            <v-row
              style="min-height: 41px; border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Class</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <v-chip
                  small
                  :color="item && item.class ? item.class.color : 'grey'"
                  text-color="white"
                >
                  {{ item && item.class ? item.class.name : '' }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row style="min-height: 41px; border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Project</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.project }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Floor</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.project_floor }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">#WO</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.wo_number }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);" v-if="isWindows">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Window Count</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.window_count }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);" v-if="isDoors">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Door Count</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.door_count }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);" v-if="isWindows">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Verticals</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.window_vertical_count }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);" v-if="isWindows">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Horizontals</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.window_horizontal_count }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Total Rel.Qty</span>
              </v-col>
              <v-col style="line-height: 16px;">
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.total_release_qty }}</span>
              </v-col>
            </v-row>
            <v-row
              style="border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Stage</span>
              </v-col>

              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                    M
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  class="box"
                  :style="`cursor: default; border-radius: 4px; border: 1.5px solid #FFD84D; background-color: ${item.is_material_available ? '#FFD84D' : ''}`"
                >
                  <span
                    v-if="item.is_material_available"
                    style="color: #000000;"
                  >M</span>
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  CBP
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :ripple="false"
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_cutting_before_paint > 0 ? '#FFD84D' : item.is_fabrication == 1 ? '#4CAF50' : ''}; background-color: ${item.total_cutting_before_paint > 0 ? '#FFD84D' : item.is_fabrication == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdMaterialAvailable, 'Cutting Before Paint', cuttingBeforePaintId)"
                >
                  <span
                    v-if="item.total_cutting_before_paint > 0"
                    style="color: #000000;"
                  >{{ item.total_cutting_before_paint }}</span>
                  <span
                    v-else-if="item.is_fabrication == 1"
                    style="color: #FFFFFF;"
                  >CBP</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  F
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_fabrication > 0 ? '#FFD84D' : item.is_assembly_before_paint == 1 ? '#4CAF50' : ''}; background-color: ${item.total_fabrication > 0 ? '#FFD84D' : item.is_assembly_before_paint == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdFabrication, 'Fabrication', fabricationId)"
                >
                  <span
                    v-if="item.total_fabrication > 0"
                    style="color: #000000;"
                  >{{ item.total_fabrication }}</span>
                  <span
                    v-else-if="item.is_assembly_before_paint == 1"
                    style="color: #FFFFFF;"
                  >F</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  ABP
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_assembly_before_paint > 0 ? '#FFD84D' : item.is_welding == 1 ? '#4CAF50' : ''}; background-color: ${item.total_assembly_before_paint > 0 ? '#FFD84D' : item.is_welding == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdAssemblyBeforePaint, 'Assembly Before Paint', assemblyBeforePaintId)"
                >
                  <span
                    v-if="item.total_assembly_before_paint > 0"
                    style="color: #000000;"
                  >{{ item.total_assembly_before_paint }}</span>
                  <span
                    v-else-if="item.is_welding == 1"
                    style="color: #FFFFFF;"
                  >ABP</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  W
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_welding > 0 ? '#FFD84D' : item.is_shipping_for_paint == 1 ? '#4CAF50' : ''}; background-color: ${item.total_welding > 0 ? '#FFD84D' : item.is_shipping_for_paint == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdWelding, 'Welding', weldingId)"
                >
                  <span
                    v-if="item.total_welding > 0"
                    style="color: #000000;"
                  >{{ item.total_welding }}</span>
                  <span
                    v-else-if="item.is_shipping_for_paint == 1"
                    style="color: #FFFFFF;"
                  >W</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  SP
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_shipping_for_paint > 0 ? '#FFD84D' : item.is_hardware == 1 ? '#4CAF50' : ''}; background-color: ${item.total_shipping_for_paint > 0 ? '#FFD84D' : item.is_hardware == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdShippingForPaint, 'Shipping For Paint', shippingForPaintId)"
                >
                  <span
                    v-if="item.total_shipping_for_paint > 0"
                    style="color: #000000;"
                  >{{ item.total_shipping_for_paint }}</span>
                  <span
                    v-else-if="item.is_hardware == 1"
                    style="color: #FFFFFF;"
                  >SP</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  H
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_hardware > 0 ? '#FFD84D' : item.is_cut == 1 ? '#4CAF50' : ''}; background-color: ${item.total_hardware > 0 ? '#FFD84D' : item.is_cut == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdHardware, 'Hardware', hardwareId)"
                >
                  <span
                    v-if="item.total_hardware > 0"
                    style="color: #000000;"
                  >{{ item.total_hardware }}</span>
                  <span
                    v-else-if="item.is_cut == 1"
                    style="color: #FFFFFF;"
                  >H</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  C
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_cut > 0 ? '#FFD84D' : item.is_brackets == 1 ? '#4CAF50' : ''}; background-color: ${item.total_cut > 0 ? '#FFD84D' : item.is_brackets == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdCutting, 'Cutting', cutId)"
                >
                  <span
                    v-if="item.total_cut > 0"
                    style="color: #000000;"
                  >{{ item.total_cut }}</span>
                  <span
                    v-else-if="item.is_brackets == 1"
                    style="color: #FFFFFF;"
                  >C</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  B
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_bracket > 0 ? '#FFD84D' : item.is_assembled == 1 ? '#4CAF50' : ''}; background-color: ${item.total_bracket > 0 ? '#FFD84D' : item.is_assembled == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdBrackets, 'Brackets', bracketsId)"
                >
                  <span
                    v-if="item.total_bracket > 0"
                    style="color: #000000;"
                  >{{ item.total_bracket }}</span>
                  <span
                    v-else-if="item.is_assembled == 1"
                    style="color: #FFFFFF;"
                  >B</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-2 pl-2"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500; text-align: center;">
                  A
                </div>
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  color="#FFD84D"
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_assembled > 0 ? '#FFD84D' : item.is_assembled == 1 ? '#4CAF50' : ''}; background-color: ${item.total_assembled > 0 ? '#FFD84D' : item.is_assembled == 1 ? '#4CAF50' : ''}`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdAssembled, 'Assembled', assembledId)"
                >
                  <span
                    v-if="item.total_assembled > 0"
                    style="color: #000000;"
                  >{{ item.total_assembled }}</span>
                  <span
                    v-else-if="item.is_assembled == 1"
                    style="color: #FFFFFF;"
                  >A</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
            </v-row>

            <v-row
              style="border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Prod.Backlog</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <v-btn
                  v-if="item.total_prod_backlog || item.total_prod_backlog == 0"
                  elevation="0"
                  fab
                  outlined
                  tile
                  class="box"
                  :style="`border-radius: 4px; border: 1.5px solid ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'} ;`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdAssembled, 'Production Backlog', finishedGoodId)"
                >
                  <span
                    style="color: #FFFFFF;"
                  >{{ item.total_prod_backlog || item.total_prod_backlog == 0 ? item.total_prod_backlog : '' }}</span>
                </v-btn>
                <a
                  v-else
                >-</a>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Ship.Backlog</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <v-btn
                  v-if="item.is_shipping && item.total_shipping >= 0"
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  class="box"
                  :style="`cursor: default; border-radius: 4px; border: 1.5px solid ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'};`"
                  @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdShipped, 'Shipping Backlog', shippedId)"
                >
                  <span
                    style="color: #FFFFFF;"
                  >{{ item.total_shipping || item.total_shipping == 0 ? item.total_shipping : '' }}</span>
                </v-btn>
                <a
                  v-else
                >-</a>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">SP PO#</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span v-if="item.sp_po_number">{{ item.sp_po_number }}</span>
                <span v-else>N/A</span>
              </v-col>
            </v-row>
            <v-row
              style="border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Glass Note</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <v-btn
                  v-if="item.sp_note_status"
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :color="item.sp_note_status.color"
                  :style="{
                    cursor: 'default',
                    borderRadius: '4px',
                    width: item.sp_note_status.name === 'N/A' || item.sp_note_status.name === 'PEN' || (item.sp_note_status.id === noteStatusIdShort && item.sp_note.length) > 2 ? 'auto' : '28px',
                    height: '28px',
                    padding: '0 7px',
                    border: `1.5px solid ${item.sp_note_status.color}`,
                    backgroundColor: `${item.sp_note_status.color}`
                  }"
                >
                  <span
                    v-if="item.sp_note_status.id === noteStatusIdShort"
                    style="color: #000000;"
                  >-{{ item.sp_note }}</span>
                  <span
                    v-else
                    style="color: #000000;"
                  >{{ item.sp_note_status.name }}</span>
                </v-btn>
                <v-btn
                  v-else
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :style="{
                    cursor: 'default',
                    borderRadius: '4px',
                    width: 'auto',
                    height: '28px',
                    padding: '0 7px',
                    border: `1.5px solid #E0E0E0`,
                    backgroundColor: `#E0E0E0`
                  }"
                >
                  <span>N/A</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">S/U PO#</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <span v-if="item.su_po_number">{{ item.su_po_number }}</span>
                <span v-else>N/A</span>
              </v-col>
            </v-row>
            <v-row
              style="border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Glass Note</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <v-btn
                  v-if="item.su_note_status"
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :color="item.su_note_status.color"
                  :style="{
                    cursor: 'default',
                    borderRadius: '4px',
                    width: item.su_note_status.name === 'N/A' || item.su_note_status.name === 'PEN' || (item.su_note_status.id === noteStatusIdShort && item.su_note.length > 2) ? 'auto' : '28px',
                    height: '28px',
                    padding: '0 7px',
                    border: `1.5px solid ${item.su_note_status.color}`,
                    backgroundColor: `${item.su_note_status.color}`
                  }"
                >
                  <span
                    v-if="item.su_note_status.id === noteStatusIdShort"
                    style="color: #000000;"
                  >-{{ item.su_note }}</span>
                  <span
                    v-else
                    style="color: #000000;"
                  >{{ item.su_note_status.name }}</span>
                </v-btn>
                <v-btn
                  v-else
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :style="{
                    cursor: 'default',
                    borderRadius: '4px',
                    width: 'auto',
                    height: '28px',
                    padding: '0 7px',
                    border: `1.5px solid #E0E0E0`,
                    backgroundColor: `#E0E0E0`
                  }"
                >
                  <span>N/A</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">SG PO#</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <span v-if="item.sg_po_number">{{ item.sg_po_number }}</span>
                <span v-else>N/A</span>
              </v-col>
            </v-row>
            <v-row
              style="border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Glass Note</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <v-btn
                  v-if="item.sg_note_status"
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :color="item.sg_note_status.color"
                  :style="{
                    cursor: 'default',
                    borderRadius: '4px',
                    width: item.sg_note_status.name === 'N/A' || item.sg_note_status.name === 'PEN' || (item.sg_note_status.id === noteStatusIdShort && item.sg_note.length > 2) ? 'auto' : '28px',
                    height: '28px',
                    padding: '0 7px',
                    border: `1.5px solid ${item.sg_note_status.color}`,
                    backgroundColor: `${item.sg_note_status.color}`
                  }"
                >
                  <span
                    v-if="item.sg_note_status.id === noteStatusIdShort"
                    style="color: #000000;"
                  >-{{ item.sg_note }}</span>
                  <span
                    v-else
                    style="color: #000000;"
                  >{{ item.sg_note_status.name }}</span>
                </v-btn>
                <v-btn
                  v-else
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :style="{
                    cursor: 'default',
                    borderRadius: '4px',
                    width: 'auto',
                    height: '28px',
                    padding: '0 7px',
                    border: `1.5px solid #E0E0E0`,
                    backgroundColor: `#E0E0E0`
                  }"
                >
                  <span>N/A</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Glass Req. By</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.glass_required_by_short }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Panned Ship Date</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.planned_ship_date_short }}</span>
              </v-col>
            </v-row>
            <v-row
              v-if="item.last_note"
              align="center"
            >
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Note</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <span
                  style="color: rgb(255, 152, 0);"
                >
                  <v-btn
                    icon
                    small
                    @click="openNotes(item.id)"
                  >
                    <v-icon
                      small
                      style="color: rgb(255, 152, 0);"
                    >
                      mdi-eye
                    </v-icon>
                  </v-btn></span>
                <span>{{ item.last_note }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <confirm-form ref="confirmForm" />
    <commercial-schedule-form
      ref="commercialForm"
      @success="get()"
    />
    <commercial-schedule-note-form
      ref="noteForm"
      @success="get()"
    />
    <!-- <commercial-schedule-history-form
      ref="historyForm"
      @success="get()"
    /> -->

    <commercial-schedule-last-stage-form
      ref="lastStageForm"
      @success="get()"
    />
    <!-- <truck-schedule-approve-form
      ref="approveForm"
      @success="get()"
    /> -->
    <commercial-schedule-finished-good-form
      ref="commercialScheduleFinishedGoodForm"
      @success="get()"
    />
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CommercialScheduleForm from '@/components/forms/commercialSchedules/CommercialScheduleForm';
import CommercialScheduleNoteForm from '@/components/forms/commercialSchedules/CommercialScheduleNoteForm';
import CommercialScheduleLastStageForm from '@/components/forms/commercialSchedules/CommercialScheduleLastStageForm';
import TruckScheduleApproveForm from '@/components/forms/truckSchedules/TruckScheduleApproveForm';
import CommercialScheduleFinishedGoodForm from '@/components/forms/commercialSchedules/CommercialScheduleFinishedGoodForm';

export default {
  components: {
    CommercialScheduleForm,
    CommercialScheduleNoteForm,
    CommercialScheduleLastStageForm,
    TruckScheduleApproveForm,
    CommercialScheduleFinishedGoodForm,
  },
  props: {

  },
  data: () => ({
    item: null,
    itemId: null,
    dialog: false,

    statusIdInProgress: 1,
    statusIdCompleted: 2,

    noteStatusIdShort: 2,

    //these are actually stage progressions
    materialAvailableId: 1,
    cuttingBeforePaintId: 2,
    fabricationId: 3,
    assemblyBeforePaintId: 4,
    weldingId: 5,
    shippingForPaintId: 6,
    hardwareId: 7,
    cutId: 8,
    bracketsId: 9,
    assembledId: 10,
    finishedGoodId: 11,
    bundledId: 12,
    onSkidId: 13,
    loadedId: 14,
    shippedId: 15,
    receivedId: 16,
    returnedId: 17,
    quarantinedId: 18,

    finishedGoodCommercialStatusIdMaterialAvailable: 2,
    finishedGoodCommercialStatusIdCuttingBeforePaint: 14,
    finishedGoodCommercialStatusIdFabrication: 15,
    finishedGoodCommercialStatusIdAssemblyBeforePaint: 16,
    finishedGoodCommercialStatusIdWelding: 17,
    finishedGoodCommercialStatusIdShippingForPaint: 18,
    finishedGoodCommercialStatusIdHardware: 19,
    finishedGoodCommercialStatusIdCutting: 3,
    finishedGoodCommercialStatusIdBrackets: 5,
    finishedGoodCommercialStatusIdAssembled: 4,
    finishedGoodCommercialStatusIdFinishedGoods: 8,
    finishedGoodCommercialStatusIdShipped: 9,
    finishedGoodCommercialStatusIdReceived: 10,
    finishedGoodCommercialStatusIdReturned: 12,
    finishedGoodCommercialStatusIdQuarantined: 13,

    jobSubClassIdCommWindows: 5,
    jobSubClassIdCommDoors: 7,

    roles: [],

    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdProductionSupervisor: 18,
    userRoleIdProductionAdmin: 22,
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    ...mapGetters([

    ]),
    isWindows() {
      if (!this.item) return false;
      return this.item.sub_class_id === this.jobSubClassIdCommWindows;
    },
    isDoors() {
      if (!this.item) return false;
      return this.item.sub_class_id === this.jobSubClassIdCommDoors;
    },
  },
  watch: {

  },
  created() {
    this.roles = this.user.roles.map((x) => x.id);
  },
  methods: {

    async get() {
      if (!this.itemId) return;
      const submitModel = {
        filters: {
          id: this.itemId,
        },
      };
      const res = await this.$api.commercialSchedule.read(submitModel);
      const firstIndex = 0;
      if (!res || !res.data || res.data.length === 0) {
        return;
      }
      this.item = res.data[firstIndex];
    },

    async open(id) {
      this.itemId = id;
      await this.get();
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$emit('success');
    },

    async finishStage(itemId, status) {
      let title = '';

      switch (status) {
        case this.materialAvailableId:
          title = 'Are you sure that you want to FINISH MATERIAL AVAILABLE?';
          break;
        case this.cuttingBeforePaintId:
          title = 'Are you sure that you want to FINISH CUTTING BEFORE PAINT?';
          break;
        case this.fabricationId:
          title = 'Are you sure that you want to FINISH FABRICATION?';
          break;
        case this.assemblyBeforePaintId:
          title = 'Are you sure that you want to FINISH ASSEMBLY BEFORE PAINT?';
          break;
        case this.weldingId:
          title = 'Are you sure that you want to FINISH WELDING?';
          break;
        case this.shippingForPaintId:
          title = 'Are you sure that you want to FINISH SHIPPING FOR PAINT?';
          break;
        case this.hardwareId:
          title = 'Are you sure that you want to FINISH HARDWARE?';
          break;
        case this.cutId:
          title = 'Are you sure that you want to FINISH CUTTING?';
          break;
        case this.bracketsId:
          title = 'Are you sure that you want to FINISH BRACKETS?';
          break;
        case this.assembledId:
          this.$refs.lastStageForm.open(itemId);
          break;
        default:
          break;
      }

      const confirm = await this.$refs.confirmForm.open({
        title,
      });
      if (!confirm) return;
      const submitModel = {
        id: itemId,
        status,
      };
      const res = await this.$api.commercialSchedule.store(submitModel, 'stage');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    openEdit(item) {
      if (item.job_id) {
        this.$refs.commercialForm.open(item.id);
      } else {
        this.$refs.manualForm.open(item.id);
      }
    },

    openNotes(id) {
      this.$refs.noteForm.open(id);
    },

    // openHistory(id) {
    //   this.$refs.historyForm.open(id);
    // },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.commercialSchedule.delete(id);
      this.$bus.$emit('loading');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async cancelStage(itemId, status) {
      let title = '';

     switch (status) {
        case this.materialAvailableId:
          title = 'Are you sure that you want to CANCEL MATERIAL AVAILABLE?';
          break;
        case this.cuttingBeforePaintId:
          title = 'Are you sure that you want to CANCEL CUTTING BEFORE PAINT?';
          break;
        case this.fabricationId:
          title = 'Are you sure that you want to CANCEL FABRICATION?';
          break;
        case this.assemblyBeforePaintId:
          title = 'Are you sure that you want to CANCEL ASSEMBLY BEFORE PAINT?';
          break;
        case this.weldingId:
          title = 'Are you sure that you want to CANCEL WELDING?';
          break;
        case this.shippingForPaintId:
          title = 'Are you sure that you want to CANCEL SHIPPING FOR PAINT?';
          break;
        case this.hardwareId:
          title = 'Are you sure that you want to CANCEL HARDWARE?';
          break;
        case this.cutId:
          title = 'Are you sure that you want to CANCEL CUTTING?';
          break;
        case this.bracketsId:
          title = 'Are you sure that you want to CANCEL BRACKETS?';
          break;
        case this.assembledId:
          title = 'Are you sure that you want to CANCEL ASSEMBLING?';
          break;
        default:
          break;
      }
      const confirm = await this.$refs.confirmForm.open({
        title,
      });
      if (!confirm) return;
      const submitModel = {
        id: itemId,
        status,
      };
      const res = await this.$api.commercialSchedule.store(submitModel, 'cancel-stage');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async toggle(id, statusId) {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${statusId === this.statusIdInProgress ? 'COMPLETE' : 'RESTORE'}?`,
      });
      if (!confirm) return;
      const res = await this.$api.commercialSchedule.get(`toggle/${id}/${statusId}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.close();
    },

    getItemColor(item) {
      if (item.is_cutting_before_paint === 1 && item.total_cutting_before_paint === 0) {
        return '#5A00FF';
      } if (item.is_fabrication === 1 && item.total_fabrication === 0) {
        return '#0081FF';
      } if (item.is_assembly_before_paint === 1 && item.total_assembly_before_paint === 0) {
        return '#FF6F5E';
      } if (item.is_welding === 1 && item.total_welding === 0) {
        return '#C46B00';
      } if (item.is_shipping_for_paint === 1 && item.total_shipping_for_paint === 0) {
        return '#FF00A8';
      } if (item.is_hardware === 1 && item.total_hardware === 0) {
        return '#424242';
      } if (item.is_cut === 1 && item.total_cut === 0) {
        return '#1870CB';
      } if (item.is_brackets === 1 && item.total_brackets === 0) {
        return '#9C27B0';
      } if (item.is_assembled === 1 && item.total_assembled === 0) {
        return '#00BFA5';
      }
      return '#F7A51C';
    },

    getItemName(item) {
      if (item.is_cutting_before_paint === 1 && item.total_cutting_before_paint === 0) {
        return 'FABRICATION';
      } if (item.is_fabrication === 1 && item.total_fabrication === 0) {
        return 'ASSEMBLY BEFORE PAINT';
      } if (item.is_assembly_before_paint === 1 && item.total_assembly_before_paint === 0) {
        return 'WELDING';
      } if (item.is_welding === 1 && item.total_welding === 0) {
        return 'SHIPPING FOR PAINT';
      } if (item.is_shipping_for_paint === 1 && item.total_shipping_for_paint === 0) {
        return 'HARDWARE';
      } if (item.is_hardware === 1 && item.total_hardware === 0) {
        return 'CUT';
      } if (item.is_cut === 1 && item.total_cut === 0) {
        return 'BRACKETS';
      } if (item.is_brackets === 1 && item.total_brackets === 0) {
        return 'ASSEMBLED';
      } if (item.is_assembled === 1 && item.total_assembled === 0) {
        return 'COMPLETE';
      }
      return 'MATERIAL';
    },

    openCommercialScheduleFinishedGoodForm(item, statusId, stageName, stageId) {
      if (!this.roles.includes(this.userRoleIdAdmin) && !this.roles.includes(this.userRoleIdProductionAdmin) && !this.roles.includes(this.userRoleIdAssociate) && !this.roles.includes(this.userRoleIdProductionSupervisor)) return;
      this.$refs.commercialScheduleFinishedGoodForm.open(item, statusId, stageName, stageId);
    },

    // openTruckForm(item) {
    //   this.$refs.approveForm.openCommercialSchedule(item);
    // },
  },
};
</script>

<style scoped>
.box
{
  border-radius: 4px;
  width: 27px;
  height: 27px;
}

.empty-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFFFFF;
}

.red-box
{
  border: 1.5px solid #F44336;
  background-color: #F44336;
}

.yellow-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFD84D;
}

.green-box
{
  border: 1.5px solid #4CAF50;
  background-color: #4CAF50;
}
</style>
